import { Injectable } from "@angular/core";

/*
 * JavaScript CRC-32 implementation
 */
@Injectable({
    providedIn: "root",
})
export class Crc32 {
    /* eslint-disable no-bitwise */
    private crc32Generate(reversedPolynomial) {
        const table = new Array();
        let i;
        let j;
        let n;

        for (i = 0; i < 256; i++) {
            n = i;
            for (j = 8; j > 0; j--) {
                if ((n & 1) === 1) {
                    n = (n >>> 1) ^ reversedPolynomial;
                } else {
                    n = n >>> 1;
                }
            }
            table[i] = n;
        }

        return table;
    }

    private crc32Initial() {
        return 0xffffffff;
    }

    private crc32AddByte(table, crc, byte) {
        return (crc >>> 8) ^ table[byte ^ (crc & 0x000000ff)];
    }

    private crc32Final(crc) {
        const _crc = ~crc;
        return _crc < 0 ? 0xffffffff + _crc + 1 : _crc;
    }

    crc32ComputeString(reversedPolynomial, str) {
        const table = this.crc32Generate(reversedPolynomial);
        let crc = 0;
        let i;

        crc = this.crc32Initial();

        for (i = 0; i < str.length; i++) {
            crc = this.crc32AddByte(table, crc, str.charCodeAt(i));
        }

        crc = this.crc32Final(crc);
        return crc;
    }

    getCrc(reversedPolynomial, str) {
        const tmpCRC = this.crc32ComputeString(reversedPolynomial, str).toString(16).toUpperCase();
        return ("00000000" + tmpCRC).slice(-8);
    }
    /* eslint-enable no-bitwise */
}
